module.exports = "/_next/static/images/klarna-7298e8412cf315d51063725632bdbeb8.svg";